import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="font-mono-tel text-xs text-zinc-500 uppercase tracking-widest">
          <span className="pulse-line">Loading telemetry…</span>
        </div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
